import { supabase } from '../lib/supabase/client';

export default async function deletePaymentRecord(paymentId?: string | null) {
  if (!paymentId) {
    console.error('No payment ID provided');
    return;
  }

  const token = (await supabase.auth.getSession()).data.session?.access_token;
  if (!token) {
    console.error('No authentication token found');
    return;
  }

  try {
    const { error } = await supabase.functions.invoke(
      `payments-history/${paymentId}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (error) {
      console.error('Error fetching invoice:', error.message);
      return;
    }
  } catch (error) {
    console.error('Unexpected error fetching invoice:', error);
    return;
  }
}
